import { render } from "./WorkOrderManagementDashboard.vue?vue&type=template&id=5aa5b4b6&ts=true"
import script from "./WorkOrderManagementDashboard.vue?vue&type=script&lang=ts"
export * from "./WorkOrderManagementDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__